
<template >
  <div>

    <van-nav-bar
      title="消息列表"
      left-text="返回"
      left-arrow
      @click-left="$router.back()"
      id="topbar"
    />
    <div style="margin-top: 60px">

      <van-card
        v-for="(item,index) in list"
        :key="index"
        title="整改逾期提醒"
      >
        <template #desc>
          <div style="padding: 10px;font-size: 16px">
            <span>{{item.context}}</span>
          </div>
        </template>
        <template #footer>
          <div>
            <span>{{item.createTime}}</span>
          </div>
        </template>
      </van-card>


    </div>




  </div>
</template>

<script>
import $ from '@/fly'
import { Toast } from 'vant';
export default {
  name: 'index',
  data () {
    return {
      list: [],
    }
  },
  methods:{
    getList(){
      $.get('/overdue/notrectified/findList').then(res=>{
        this.list = res
      })
    },
  },
  mounted() {
    this.getList()
  }

}
</script>

<style lang="less" scoped>


/deep/.van-card{
  background-color: #fffbe8;
}
/deep/.van-card__title{
  padding: 10px 0;
  font-size: 18px;
  color: #ed6a0c;
}
/deep/.van-ellipsis{
  font-size: 16px;


}
/deep/.van-card__desc{
  font-color: #ed6a0c !important;
  color: #ed6a0c;
}
/deep/.van-card__footer{
  font-size: 14px;
  color: #ed6a0c;
}

</style>
